import { useState } from "react";
import { useNavigate } from "react-router-dom"
import { useGenericFormValidator } from "../../../util/genericFormValidator";
import { patternsValidators } from "../../../model/enum";
import { isValidCPF, isValidPassword } from "../../../util/validators";
import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { actionLoginUser } from "../../../redux/user/actions";
import { useRedux } from "../../../redux/hook/useRedux";
import { useUserData } from "../../../context/UserDataContext";
import { useBenefit } from "../../../context/BenefitSelectedContext";

export const useLogin = () => {
    const { setBenefitSelected } = useBenefit();
    const { setUser } = useUserData();
    const navigate = useNavigate();
    const [showInput, setShowInput] = useState(false)
    const { dispatch } = useRedux();
    const [show, setShow] = useState(false);

    const initialForm = {
        email: '',
        password: ''
    }

    const personalDataFormRules = {
        email: {
            required: true,
            pattern: patternsValidators.email
        },
        password: {
            required: true,
            custom: (value) => isValidPassword(value)
        }
    }

    const { form, handleChange, validate, errors } = useGenericFormValidator(initialForm, personalDataFormRules)

    const onSubmitLogin = () => {
        const isValid = validate();
        if (isValid) {
            dispatch(actionLoginUser({
                email: form.email,
                password: form.password
            }, (user) => {
                setUser(user);
                user.beneficiosProdutos && setBenefitSelected(user.beneficiosProdutos[0].codigoBeneficio)
                navigate('/dashboard');
            }))
        }
    }

    return {
        navigate,
        showInput,
        setShowInput,
        form,
        handleChange,
        errors,
        onSubmitLogin,
        show, 
        setShow
    }
}